import React, { useState, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { IntlProvider } from 'react-intl';
import { useUpdateEffect } from 'react-use';
import '@formatjs/intl-pluralrules/polyfill';
import '@formatjs/intl-pluralrules/locale-data/ru';
import '@formatjs/intl-pluralrules/locale-data/uk';
import axios from 'axios/index';
import { loader } from '../helpers/loader';
import '../Building/BuildingMenu/BuildingMenu';
import '../Building/BuildingSubscribe/BuildingSubscribe';
import '../DeveloperQuestionPopup/DeveloperQuestionPopup';
import PlansFilter from './PlansFilter/PlansFilter';
import messagesUk from './locale/uk.json';
import messagesRu from './locale/ru.json';
import { syncFavorite } from '../helpers/favorites';
import { replaceUrl } from '../helpers/query-string';
import { initViewHeight } from '../helpers/view-height';
import {
  FlatsFiltersContentContext,
  FlatsFiltersOpenedContext,
} from '../FlatsFilters/FlatsFiltersContext';
import { attachListenersPlanCards } from '../PlanModal/PlanModal';
import './Plans.scss';

const getActiveFiltersCount = (params) => {
  const activeFilters = Object.keys(params).filter((param) => {
    if (Array.isArray(params[param])) {
      return params[param].length !== 0;
    }
    return params[param];
  });

  return activeFilters.length;
};

const Plans = () => {
  const messages = {
    uk: messagesUk,
    ru: messagesRu,
  };
  const [searchParams, setSearchParams] = useState(window.params.searchParams);
  const [activeFiltersCount, setActiveFiltersCount] = useState(getActiveFiltersCount(searchParams));
  const [plansCount, setPlansCount] = useState(window.params.plansCount);
  const [opened, setOpened] = useState(false);
  const locale = window.currentLanguage;

  const updateSearchParams = (params) => {
    const newParams = {};
    Object.keys(params).forEach((key) => {
      newParams[key] = params[key];
    });
    setActiveFiltersCount(getActiveFiltersCount(newParams));
    setSearchParams(newParams);
  };

  useEffect(() => {
    syncFavorite();
  }, []);

  useUpdateEffect(() => {
    const updateContent = (params) => {
      loader.show();
      axios({
        url: '/api/filter/layout',
        method: 'post',
        headers: {
          'X-CSRF-Token': window.csrf,
          'Content-type': 'application/json',
        },
        withCredentials: true,
        data: {
          building_id: window.params.buildingId,
          lang: window.currentLanguage,
          ...params,
        },
      }).then((response) => {
        loader.hide();
        replaceUrl({ path: window.params.baseUrl, params });
        document.querySelector('#plans-wrapper').innerHTML = response.data.html;
        window.params.modalsData = response.data.modalsData;
        attachListenersPlanCards(searchParams);
        setPlansCount(response.data.count);
        syncFavorite();
      });
    };
    updateContent(searchParams);
  }, [searchParams]);

  return (
    <IntlProvider locale={locale} messages={messages[locale]}>
      <FlatsFiltersOpenedContext.Provider value={[opened, setOpened]}>
        <FlatsFiltersContentContext.Provider
          value={{
            searchParams,
            updateSearchParams,
            flatsCount: plansCount,
            activeFiltersCount,
          }}
        >
          <PlansFilter opened={opened} requestUrl="/api/flats-filters-config" />
        </FlatsFiltersContentContext.Provider>
      </FlatsFiltersOpenedContext.Provider>
    </IntlProvider>
  );
};

const initPlans = () => {
  initViewHeight();
  attachListenersPlanCards(window.params.searchParams);

  const container = document.querySelector('#filter-wrapper');
  if (container) {
    const root = createRoot(container);
    root.render(<Plans />);
  }
};

initPlans();
